<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <router-link class="navbar-brand" :to="{ name: 'home' }">
      <img
        src="../../public/img/icons/icon_no_bg.png"
        style="width: 36px;margin-right: 10px;vertical-align: top;"
      />
      <span class="text-primary">Lunch</span>Menu
    </router-link>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="isAuthenticated" :to="{ name: 'orders' }">訂單</b-nav-item>
        <b-nav-item
          v-if="isAuthenticated"
          :to="{ name: 'editor-menu', params:{slug:currentUser.account} }"
        >編輯菜單</b-nav-item>
        <b-nav-item
          v-if="isAuthenticated"
          :to="{ name: 'editor-signboard', params:{slug:currentUser.account} }"
        >編輯招牌</b-nav-item>
        <b-nav-item v-if="prompt" @click="deferredPrompt">加到主頁面</b-nav-item>
        <b-nav-item :to="{name:'signboards'}">開始點餐</b-nav-item>
        <b-nav-item-dropdown text="訂單紀錄" v-if="orderHistory.length > 0" right>
          <b-dropdown-item
            v-for="order in orderHistory"
            :key="order.orderId"
            :to="{path:'/order/' + order.orderId}"
          >{{order.orderId}}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RwvHeader",
  methods: {
    deferredPrompt() {
      if (window.deferredPrompt) {
        window.deferredPrompt.prompt();
        window.deferredPrompt.userChoice.then(choiceResult => {
          console.log(choiceResult.outcome);
          if (choiceResult.outcome === "dismissed") {
            console.log("dismissed");
          } else {
            console.log("accepted");
            this.$store.dispatch("promptToggle");
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated", "orderHistory", "prompt"])
  }
};
</script>
